interface LoadingSpinnerProps {
  message?: string
}

export default function LoadingSpinner({ message = 'Loading...' }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center p-12 gap-3">
      <span className="spinner h-8 w-8" />
      <span className="text-sm text-muted-foreground">{message}</span>
    </div>
  )
}
